import Vue from "vue"
import Router from "vue-router"
import Home from "./views/Home.vue"
import store from "@/store"

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "is-active",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        auth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/Login.vue"),

      meta: {
        guest: true
      }
    },
    {
      path: "/customers",
      name: "customers.index",
      component: () => import("@/views/Customers/Index.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/customers/new",
      name: "customers.create",
      component: () => import("@/views/Customers/Create.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/customers/:id",
      name: "customers.show",
      component: () => import("@/views/Customers/Show.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/products",
      name: "products.index",
      component: () => import("@/views/Products/Index.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/products/new",
      name: "products.create",
      component: () => import("@/views/Products/Create.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/products/:id",
      name: "products.show",
      component: () => import("@/views/Products/Show.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/product-types",
      name: "productTypes.index",
      component: () => import("@/views/ProductTypes/Index.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/product-types/new",
      name: "productTypes.create",
      component: () => import("@/views/ProductTypes/Create.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/product-types/:id",
      name: "productTypes.show",
      component: () => import("@/views/ProductTypes/Show.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/contracts",
      name: "contractTypes.index",
      component: () => import("@/views/ContractTypes/Index.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/contracts/new",
      name: "contractTypes.create",
      component: () => import("@/views/ContractTypes/Create.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/contracts/:id",
      name: "contractTypes.show",
      component: () => import("@/views/ContractTypes/Show.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/course-types",
      name: "courseTypes.index",
      component: () => import("@/views/CourseTypes/Index.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/course-types/new",
      name: "courseTypes.create",
      component: () => import("@/views/CourseTypes/Create.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/course-types/:id",
      name: "courseTypes.show",
      component: () => import("@/views/CourseTypes/Show.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/estimates",
      name: "estimates.index",
      component: () => import("@/views/Estimates/Index.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/estimates/new",
      name: "estimates.create",
      component: () => import("@/views/Estimates/Create.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/estimates/:id/print",
      name: "estimates.print",
      component: () => import("@/views/Estimates/Print.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/estimates/:id/printsecurity",
      name: "estimates.printSecurity",
      component: () => import("@/views/Estimates/PrintSecurity.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/estimates/:id/printsecurity2",
      name: "estimates.printSecurity2",
      component: () => import("@/views/Estimates/PrintSecurity2.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/estimates/:id",
      name: "estimates.show",
      component: () => import("@/views/Estimates/Show.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/support-contracts",
      name: "supportContracts.index",
      component: () => import("@/views/SupportContracts/Index.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/product-contracts",
      name: "productContracts.index",
      component: () => import("@/views/ProductContracts/Index.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/course-contracts",
      name: "courseContracts.index",
      component: () => import("@/views/CourseContracts/Index.vue"),

      meta: {
        auth: true
      }
    },
    {
      path: "/marketing-actions",
      name: "marketingActions.index",
      component: () => import("@/views/MarketingActions/Index.vue"),

      meta: {
        auth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth) && !store.state.auth.authenticated) {
    /*
     * If the user is not authenticated and visits
     * a page that requires authentication, redirect to the login page
     */
    next({
      name: "login"
    })
  } else if (
    to.matched.some(m => m.meta.guest) &&
    store.state.auth.authenticated
  ) {
    /*
     * If the user is authenticated and visits
     * an guest page, redirect to the dashboard page
     */
    next({
      name: "home"
    })
  } else {
    next()
  }
})

export default router
